export const TAIWAN_MOBILE_PRESET = 'taiwan_mobile'

export const TAIWAN_MOBILE_REGEX =
  '^(?:09\\d{2}[-\\s]?\\d{3}[-\\s]?\\d{3}|\\+?886[-\\s]?9\\d{2}[-\\s]?\\d{3}[-\\s]?\\d{3})$'

export const TAIWAN_MOBILE_OR_LANDLINE_EXTENSION_PRESET = 'taiwan_mobile_or_landline_ext'

export const TAIWAN_MOBILE_OR_LANDLINE_EXTENSION_REGEX =
  '^(?:09\\d{2}[-\\s]?\\d{3}[-\\s]?\\d{3}|\\+?886[-\\s]?9\\d{2}[-\\s]?\\d{3}[-\\s]?\\d{3}|0\\d{1,3}-\\d{3,4}[-\\s]?\\d{3,4}(?:[-\\s]*(?:#|分機|轉|ext\\.?|x)\\s?\\d{1,6})?)$'

export const TAIWAN_LANDLINE_EXTENSION_PRESET = 'taiwan_landline_ext'

export const TAIWAN_LANDLINE_EXTENSION_REGEX =
  '^0\\d{1,3}-\\d{3,4}[-\\s]?\\d{3,4}(?:[-\\s]*(?:#|分機|轉|ext\\.?|x)\\s?\\d{1,6})?$'
